import type { Bonus, Comparison, Contrast, PromiseItem } from "../types/landing";

export const COVER_IMAGE =
  "https://cdn.magicpatterns.com/uploads/kd8AuBmhvYuQy6BEyTpqLz/portada_de_ebook.png";

export const CHECKOUT_URL = "https://digitalmind99.myshopify.com/cart/45654456893463:1";

export const pillars = [
  "Neurociencia aplicada",
  "Gratitud táctica",
  "Reprogramación mental",
  "Manifestación práctica",
  "Resiliencia emocional",
  "Acción consciente",
  "Abundancia adaptada al contexto argentino",
];

export const contrasts: Contrast[] = [
  { wish: "Quieren manifestar abundancia,", reality: "pero lo hacen desde el miedo." },
  { wish: "Quieren atraer oportunidades,", reality: "pero están mentalmente saturadas de noticias." },
  { wish: "Quieren vender, cobrar mejor o crecer,", reality: "pero sienten culpa, inseguridad o bloqueo." },
  { wish: "Quieren pensar en positivo,", reality: "pero su entorno repite todos los días que “en este país no se puede”." },
];

export const audience = [
  "Sentís ansiedad cuando pensás en dinero, precios o futuro.",
  "Estás cansado de vivir en modo supervivencia.",
  "Querés tener una mentalidad más fuerte frente a la incertidumbre.",
  "Te interesa la manifestación, pero necesitás algo más realista y aplicable.",
  "Querés dejar de absorber la negatividad del entorno.",
  "Te cuesta cobrar lo que valés o recibir sin culpa.",
  "Querés desarrollar una rutina mental que te ayude a vivir con más calma.",
  "Sentís que necesitás ordenar tu energía, tu enfoque y tu relación con la abundancia.",
];

export const chapters = [
  "Por qué la escasez se instala como un patrón mental.",
  "Cómo el contexto argentino afecta tu sistema nervioso y tus decisiones.",
  "Qué significa ser una persona anti-frágil.",
  "Cómo usar la gratitud como herramienta neurológica, no como frase vacía.",
  "Cómo cambiar tu relación emocional con el dinero.",
  "Cómo manifestar desde la acción y no desde la desesperación.",
  "Cómo protegerte de conversaciones, noticias y entornos que refuerzan el miedo.",
  "Cómo aplicar un plan de 30 días para entrenar tu nueva identidad mental.",
];

export const comparisons: Comparison[] = [
  { others: "Hablan de prosperidad", ours: "Habla de prosperidad con inflación." },
  { others: "Hablan de confianza", ours: "Habla de confianza en plena incertidumbre económica." },
  { others: "Hablan de manifestar", ours: "Explica cómo hacerlo cuando tu mente está en alerta." },
  { others: "Hablan de éxito", ours: "Entiende el cansancio emocional de vivir con inestabilidad." },
];

export const bonuses: Bonus[] = [
  { title: "Cómo cobrar lo que valés", format: "Guía", description: "Transformá tus creencias sobre dinero y merecimiento." },
  { title: "Amigos, Familias, Pesos", format: "Ebook", description: "Reflexioná sobre la relación entre vínculos, creencias y dinero." },
  { title: "50 Decretos de RPM", format: "PDF", description: "50 decretos para acompañar tu reprogramación mental." },
  { title: "Alivio Financiero Express", format: "Meditación", description: "Herramientas para transformar tu relación con tus finanzas." },
  { title: "Audio Subliminal de Abundancia", format: "Audio", description: "Afirmaciones para trabajar escasez, abundancia, prosperidad y merecimiento." },
];

export const promises: PromiseItem[] = [
  { when: "Cuando tu mente deja de estar tomada por el miedo,", then: "empezás a ver opciones." },
  { when: "Cuando bajás la ansiedad,", then: "tomás mejores decisiones." },
  { when: "Cuando entrenás gratitud,", then: "tu cerebro empieza a detectar oportunidades." },
  { when: "Cuando fortalecés tu merecimiento,", then: "dejás de sabotear tu crecimiento." },
  { when: "Cuando actuás desde calma,", then: "dejás de reaccionar desde desesperación." },
];

export const notTheMoment = [
  "El momento no es cuando el dólar baje.",
  "El momento no es cuando las noticias mejoren.",
  "El momento no es cuando todos estén de acuerdo.",
];

export const thingsThatChange = ["El entorno", "Los precios", "Las noticias", "El dólar"];
